import { useDispatch, useSelector } from "react-redux";
import { useTheme } from "@mui/styles";
import ButtonBase from "@mui/material/ButtonBase";
import React from "react";
import styled from "styled-components";
import { setCurrentlyEditingSleeper } from "../../../../redux/slices/customNavigation";
import {
  primarySleeperFirstNameSelector,
  secondarySleeperFirstNameSelector,
} from "../../../../redux/slices/mattressConfiguration";

const StyledContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  height: 100%;
`;

const StyledText = styled.div`
  font-family: noto-sans;
  font-weight: bold;
  transform: rotate(-90deg);
`;

const SleeperSelectorButtons = ({ editingSleeper1 }) => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const firstSleeperFirstName = useSelector(primarySleeperFirstNameSelector);
  const secondSleeperFirstName = useSelector(secondarySleeperFirstNameSelector);

  const sleeper1ButtonStyles = {
    transition: "background 250ms ease-in-out 0s",
    ":hover": {
      color: editingSleeper1
        ? theme.COLORS.BLUE.blueGreen1
        : theme.COLORS.BLUE.lightBlue,
    },
    color: theme.COLORS.BLUE.darkBlueGreen,
    background: editingSleeper1
      ? "transparent linear-gradient(0deg, #f0f9fe 0%, #fefefe 100%) 0% 0% no-repeat padding-box padding-box"
      : "#6aa1b8",
    width: "100%",
    height: "30vh",
    boxShadow: "3px 2px 0px #a4c3d1",
    borderRadius: editingSleeper1 ? "0 0 0 40px" : "0 0 0 0",
    position: "relative",
    zIndex: editingSleeper1 ? 200 : 10,
    marginBottom: "-50%",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-end",
  };

  const sleeper2ButtonStyles = {
    transition: "background 250ms ease-in-out 0s",
    ":hover": {
      color: editingSleeper1
        ? theme.COLORS.BLUE.lightBlue
        : theme.COLORS.BLUE.blueGreen1,
    },
    color: theme.COLORS.BLUE.darkBlueGreen,
    background: editingSleeper1
      ? "#6aa1b8"
      : "transparent linear-gradient(0deg, #e1f4fd 0%, #f1fafe 100%) 0% 0% no-repeat padding-box padding-box",
    position: "relative",
    width: "160%",
    height: "25vh",
    zIndex: editingSleeper1 ? 10 : 200,
    borderRadius: editingSleeper1 ? "0 0 0 40px" : "40px 0 0 40px",
    display: "flex",
    boxShadow: "3px 1px 2px #a2ccde",
    justifyContent: "flex-start",
  };

  return (
    <StyledContainer className="col-2">
      <ButtonBase
        sx={{
          ...sleeper1ButtonStyles,
        }}
        onClick={() => dispatch(setCurrentlyEditingSleeper(1))}
      >
        <StyledText
          style={{
            marginBottom: "100%",
            marginLeft: "10%",
          }}
        >
          {firstSleeperFirstName}
        </StyledText>
      </ButtonBase>
      <ButtonBase
        sx={{ ...sleeper2ButtonStyles }}
        onClick={() => dispatch(setCurrentlyEditingSleeper(2))}
      >
        <StyledText style={{ marginLeft: "10%" }}>
          {secondSleeperFirstName}
        </StyledText>
      </ButtonBase>
    </StyledContainer>
  );
};

export default SleeperSelectorButtons;
